import { NavLink } from "react-router";

interface Tab {
  label: string;
  to: string;
  count?: number;
}

export function TabNav({ tabs, basePath }: { tabs: Tab[]; basePath: string }) {
  return (
    <div className="mb-6 flex gap-6 overflow-x-auto overflow-y-hidden whitespace-nowrap border-b border-muted">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={`${basePath}/${tab.to}`}
          className={({ isActive }) =>
            `-mb-px flex items-center gap-2 border-b-2 pb-2 text-sm ${
              isActive
                ? "border-accent font-semibold text-accent"
                : "border-transparent font-medium text-foreground/70 hover:text-foreground"
            }`
          }
        >
          {({ isActive }) => (
            <>
              {tab.label}
              {tab.count !== undefined && (
                <span
                  className={`rounded-full px-1.5 py-px text-xs tabular-nums ${
                    isActive ? "bg-accent/15 text-accent" : "bg-surface"
                  }`}
                >
                  {tab.count}
                </span>
              )}
            </>
          )}
        </NavLink>
      ))}
    </div>
  );
}
